export const PROCESS_DESCRIPTION_MAX_LENGTH = 255;
export const PROCESS_NAME_MAX_LENGTH = 100;
export const NODE_WIDTH = 400;
export const NODE_HEIGHT = 86;
export const EXTERNAL_CODE_MAX_VALUE = 999;
export const EXTERNAL_CODE_MIN_VALUE = 1;
